import { render } from "./VPI.vue?vue&type=template&id=5d7e3677"
import script from "./VPI.vue?vue&type=script&lang=js"
export * from "./VPI.vue?vue&type=script&lang=js"

import "./VPI.vue?vue&type=style&index=0&id=5d7e3677&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__